import Icon from '@tiger/icons';
import { FC, Fragment, useState } from 'react';
import { FormControl } from 'react-bootstrap';
import { $Formutil, connect } from 'react-bootstrap-formutil';
import FormGroup from 'components/FormGroup';
import PwdRisk, { confirmPasswordChecker, pwdLengthChecker, pwdTypeChecker } from 'components/PwdRisk';
import { EventParams } from 'types/common';
import { useTrack } from 'utils/track';
import './style.scss';

export interface PasswordProps {
    $formutil: $Formutil<{
        login_password: string;
        confirm_password: string;
    }>;
    eventParams?: {
        loginPassword?: EventParams;
        confirmPassword?: EventParams;
    };
}

const parser = (value, $setViewValue) => $setViewValue(value.trim());
const Password: FC<PasswordProps> = props => {
    const { $formutil, eventParams } = props;
    const { loginPassword: loginPasswordEventParams, confirmPassword: confirmPasswordEventParams } = eventParams || {};
    const { login_password, confirm_password } = $formutil.$params;
    const [passwordShow, setPasswordShow] = useState(false);
    // 防抖应该是基于每个输入框单独进行防抖, 所以这里需要调用两次useTrace获取不同的throttleTrackEvent方法
    // 如果使用同一个防抖方法, 可能出现在后触发的埋点不能正确上报的情况
    const { debounceTrackEvent: loginPasswordTrackEvent } = useTrack();
    const { debounceTrackEvent: confirmPasswordTrackEvent } = useTrack();

    return (
        <Fragment>
            <FormGroup
                className="password-root"
                addons={{
                    end: (
                        <Icon
                            fill="gray"
                            height="20px"
                            width="20px"
                            type={passwordShow ? 'eyeInvisible' : 'eye'}
                            onClick={() => {
                                setPasswordShow(prev => !prev);
                            }}
                        />
                    )
                }}
                name="login_password"
                label={__('Password')}
                errorLevel="off"
                checker={value => {
                    if (!value) {
                        return __('Please enter your password');
                    }

                    if (!pwdLengthChecker(value)) {
                        return __(
                            'The Password must be 8-24 characters, including numbers, letters, and symbols (choose two out of three)'
                        );
                    }

                    if (!pwdTypeChecker(value)) {
                        return __('密码需包含大写字母、小写字母、数字或标点至少包含3种');
                    }

                    return true;
                }}
                $parser={parser}
                $onFieldChange={() => {
                    $formutil.$validate('confirm_password');

                    if (loginPasswordEventParams) {
                        loginPasswordTrackEvent(loginPasswordEventParams);
                    }
                }}>
                <FormControl
                    type={passwordShow ? 'text' : 'password'}
                    placeholder={__('Your password should be 8-24 characters')}
                />
            </FormGroup>

            <FormGroup
                name="confirm_password"
                label={__('Confirm Password')}
                errorLevel="off"
                checker={value => {
                    if (!confirmPasswordChecker(login_password, value)) {
                        return __('The password does not match.');
                    }

                    return true;
                }}
                $parser={parser}
                $onFieldChange={() => {
                    $formutil.$validate('login_password');

                    if (confirmPasswordEventParams) {
                        confirmPasswordTrackEvent(confirmPasswordEventParams);
                    }
                }}>
                <FormControl type="password" placeholder={__('Please re-enter your password')} />
            </FormGroup>
            <PwdRisk password={login_password} confirmPassword={confirm_password} />
        </Fragment>
    );
};

export default connect(Password);
